import { jsx as _jsx } from "react/jsx-runtime";
import { BrandList } from './brand-list';
import { useBrandsTable } from './table/use-brands-table';
export var BrandListContainer = function () {
    var _a = useBrandsTable(), table = _a.table, searchFilter = _a.searchFilter, setSearchFilter = _a.setSearchFilter, isLoading = _a.isLoading;
    return _jsx(BrandList, { table: table, isLoading: isLoading, searchTerm: searchFilter, onSearchChange: setSearchFilter });
};
